import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { Trash2, ShoppingCart } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { toast } from "sonner";

export default function Wishlist() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const data = await api.get("/wishlist");
            setItems(data);
        } catch {
            setItems([]);
        } finally { setLoading(false); }
    };
    useEffect(() => { load(); }, []);

    const remove = async (id) => {
        await api.del(`/wishlist/${id}`);
        toast.success("Removed from wishlist");
        load();
    };
    const moveToCart = async (id) => {
        await api.post("/cart", { course_id: id });
        await api.del(`/wishlist/${id}`);
        toast.success("Moved to cart");
        load();
    };

    return (
        <AppLayout searchPlaceholder="Search wishlist...">
            <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mb-2">Wishlist</h1>
            <p className="text-sm text-gray-400 mb-8">{items.length} saved course{items.length !== 1 ? "s" : ""}</p>
            {loading ? <div className="text-gray-500">Loading…</div> : items.length === 0 ? (
                <div className="bg-ink-700 rounded-3xl border border-white/5 p-10 text-center">
                    <p className="text-gray-400">Your wishlist is empty. Browse the <Link to="/catalog" className="text-lime font-semibold">catalog</Link> to start saving.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {items.map((c) => (
                        <div key={c.id} data-testid={`wishlist-${c.id}`} className="bg-ink-700 rounded-2xl border border-white/5 overflow-hidden">
                            <Link to={`/catalog/${c.id}`} className="block aspect-[4/3] overflow-hidden">
                                <img src={c.thumbnail} alt={c.title} className="w-full h-full object-cover hover:scale-105 transition-transform" />
                            </Link>
                            <div className="p-5">
                                <div className="text-xs text-grape font-semibold mb-2">{c.category}</div>
                                <h3 className="font-display font-bold text-lg leading-tight line-clamp-2">{c.title}</h3>
                                <div className="mt-4 flex items-center justify-between">
                                    <span className="font-display font-black text-xl">£{c.price}</span>
                                    <div className="flex gap-2">
                                        <button onClick={() => moveToCart(c.id)} data-testid={`move-cart-${c.id}`} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-lime text-ink-900 text-xs font-bold hover:bg-lime-hover">
                                            <ShoppingCart className="w-3.5 h-3.5" /> Cart
                                        </button>
                                        <button onClick={() => remove(c.id)} data-testid={`remove-wish-${c.id}`} className="w-9 h-9 rounded-full bg-ink-600 hover:bg-red-500/20 hover:text-red-400 text-gray-400 flex items-center justify-center transition-colors">
                                            <Trash2 className="w-3.5 h-3.5" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </AppLayout>
    );
}
